module.exports = __webpack_public_path__ + "img/BedroomofWax.7f36df42.png";